import React from 'react';
import useIntersectionAnimation from '@helpers/useIntersectionAnimation';
import { animationPresets } from '@styles/animations';
import { AnimatedElement } from './animated-element.styled';

interface AnimatedElementProps {
  children: React.ReactNode;
  animationType?: keyof typeof animationPresets;
  delay?: number;
  threshold?: number;
  rootMargin?: string;
  once?: boolean;
  className?: string;
  transformOrigin?: string;
  width?: string;
}

const AnimatedElementComponent: React.FC<AnimatedElementProps> = ({
  children,
  animationType = 'fadeIn',
  delay = 0,
  threshold = 0.1,
  rootMargin = '0px',
  once = true,
  className,
  transformOrigin = '50% 50%',
  width = 'auto',
}) => {
  const { ref, animationClass } = useIntersectionAnimation({
    threshold,
    rootMargin,
    once,
  });

  return (
    <AnimatedElement
      ref={ref}
      className={`${animationClass} ${className || ''}`}
      $animationType={animationType}
      $delay={delay}
      $transformOrigin={transformOrigin}
      $width={width}
    >
      {children}
    </AnimatedElement>
  );
};

export default AnimatedElementComponent;
